import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';

import { errs } from '@zap-onboard/errors';
import { useEffect, useState } from 'react';
import { useCurrentBusinessId } from '../auth/selectors';
import { useCurrentBusiness, useHandlerQuery } from '../hooks';
import { NominateSuperFundForm } from '../pages/Business/Settings/NominateSuperFundForm';
import { NominateSuperFundModal } from '../pages/Business/Settings/NominateSuperFundModal';
import { useAPI } from './API';

export const SuperAPINominatedSuperModal = () => {
  const businessId = useCurrentBusinessId();

  const api = useAPI();

  const nominateD = useDisclosure();

  useEffect(() => {
    return api.$error.subscribe((error) => {
      if (error instanceof errs.NoNominatedSuperError) {
        nominateD.onOpen();
      }
    });
  }, [api]);

  const fundInfo = useHandlerQuery(
    (api) => api.business().getBusinessNominatedSuper(businessId!),
    {
      key: ['BUSINESS_NOMINATED_SUPER_FUND', businessId!],
      enabled: !!businessId,
      skipRefetch: true,
      staleAfter: '1h',
    },
  );

  if (!fundInfo.data || !businessId) {
    return null;
  }

  return (
    <NominateSuperFundModal
      {...nominateD}
      context="assignmentBlocker"
      info={fundInfo.data}
    />
  );
};
